import ExpressionUtil from "./ExpressionUtil";

export default {

    /**
     * 站点信息取得
     * 
     * @param {*} vueinstance VUE实例
     */
    findSiteInfo(vueinstance) {
        // 加载开始
        vueinstance.$store.commit("loadingStart");

        // 站点切换
        var siteId = process.env.SITE_ID;
        if (vueinstance.$route.params.site_id) {
            siteId = vueinstance.$route.params.site_id;
        }

        // 发送请求
        return vueinstance.axios.post("/siteInfo/find", { "siteId": siteId })
            .then(result => {
                // 站点信息保存
                if (result) {
                    vueinstance.$store.commit("siteInfo", result);
                }else {
                    sessionStorage.clear()
                }
                // 加载完成
                vueinstance.$store.commit("loadingFinish");
                return result;
            })
            .catch(() => {
                // 加载错误
                vueinstance.$store.commit("loadingError");
            });
    },

    /**
     * 站点菜单信息取得
     * 
     * @param {*} vueinstance VUE实例
     * @param {number} type 菜单类型 ( 1:门户 2：管理 3:手机 )
     */
    findSiteMenu(vueinstance, type) {
        // 清除当前菜单
        vueinstance.$store.commit("menuInfo", []);

        // 菜单ID
        let menuId = vueinstance.$store.getters.siteInfo.consoleMenuId;
        if (type == "1") {
            menuId = vueinstance.$store.getters.siteInfo.portalMenuId;
        }

        // 发送请求
        return vueinstance.axios.post("/siteInfo/getPowerMenu", { "menuId": menuId })
            .then(result => {
                // 站点菜单信息保存
                if (result) {
                    vueinstance.$store.commit("menuInfo", result);
                    sessionStorage.setItem("menuInfo", JSON.stringify(result))
                }
                return result;
            });
    },

    /**
     * 获取验证码
     * 
     * @param {*} vueinstance VUE实例
     * @param {string} userId 用户ID
     * @param {string} password 密码
     */
    getVerificationCode(vueinstance, userId, mail) {
        // 加载开始
        vueinstance.$store.commit("loadingStart");
        vueinstance.disabled=true;
        // 发送请求
        return vueinstance.axios.post("/userInfo/forgetPassword", { "userId": userId, "mail": mail })
            .then(result => {
                // 加载完成
                vueinstance.$store.commit("loadingFinish");
                vueinstance.disabled=false;
                return result;
            })
            .catch(() => {
                // 加载错误
                vueinstance.$store.commit("loadingError");
                vueinstance.disabled=false;
            });
    },

    /**
     * 重置密码
     * 
     * @param {*} vueinstance VUE实例
     * @param {string} userId 用户ID
     * @param {string} password 密码
     */
    updPass(vueinstance, userId, mail, verificationCode, newPassword, confirmPassword) {
        // 加载开始
        vueinstance.$store.commit("loadingStart");
        vueinstance.disabled=true;
        // 发送请求
        return vueinstance.axios.post("/userInfo/resetPassword", { "userId": userId, "mail": mail, "verificationCode": verificationCode, "newPassword": newPassword ,"confirmPassword": confirmPassword})
            .then(result => {
                // 加载完成
                vueinstance.$store.commit("loadingFinish");
                vueinstance.disabled=false;
                return result;
            })
            .catch(() => {
                // 加载错误
                vueinstance.$store.commit("loadingError");
                vueinstance.disabled=false;
            });
    },

    /**
     * 用户登录认证
     * 
     * @param {*} vueinstance VUE实例
     * @param {string} userId 用户ID
     * @param {string} password 密码
     */
    userAuth(vueinstance, userId, password, isAd) {
        // 加载开始
        vueinstance.$store.commit("loadingStart");
        if(isAd === "1") {
            // 发送请求
            return vueinstance.axios.post("/userInfo/auth", { "domainId": userId, "password": password, "isDomain" : isAd })
                .then(result => {
                    // 用户登录信息保存
                    console.log();
                    if (result) {
                        vueinstance.$store.commit("loginInfo", result);
                        vueinstance.$store.commit("accessToken", result.accessToken);
                        sessionStorage.setItem('userInfo',JSON.stringify(result.userInfo))
                        sessionStorage.setItem('accessToken',result.accessToken)
                    }
                    // 加载完成
                    vueinstance.$store.commit("loadingFinish");
                    return result;
                })
                .catch(() => {
                    // 加载错误
                    vueinstance.$store.commit("loadingError");
                });
          } else {
            // 发送请求
            return vueinstance.axios.post("/userInfo/auth", { "userId": userId, "password": password, "isDomain" : isAd })
                .then(result => {
                    // 用户登录信息保存
                    if (result) {
                        vueinstance.$store.commit("loginInfo", result);
                        vueinstance.$store.commit("accessToken", result.accessToken);
                        sessionStorage.setItem('userInfo',JSON.stringify(result.userInfo))
                        sessionStorage.setItem('accessToken',result.accessToken)
                    }
                    // 加载完成
                    vueinstance.$store.commit("loadingFinish");
                    return result;
                })
                .catch(() => {
                    // 加载错误
                    vueinstance.$store.commit("loadingError");
                });
          }
    },

    /**
     * 用户登录认证
     * 
     * @param {*} vueinstance VUE实例
     * @param {string} userId 用户ID
     * @param {string} password 密码
     */
    qywxUserAuth(vueinstance, code) {
        // 加载开始
        vueinstance.$store.commit("loadingStart");

        // 发送请求
        return vueinstance.axios.post("/userInfo/qywxAuth", { "userId": code })
            .then(result => {
                if (result) {
                    if (result.userInfo) {
                        // 用户登录信息保存
                        vueinstance.$store.commit("loginInfo", result);
                    } else {
                        // 企业微信信息保存
                        vueinstance.$store.commit("qywxUserInfo", result);
                    }
                }
                // 加载完成
                vueinstance.$store.commit("loadingFinish");
                return result;
            })
            .catch(result => {
                // 加载错误
                vueinstance.$store.commit("loadingError");
            });
    },

    /**
     * 域用户登录认证
     * 
     * @param {*} vueinstance VUE实例
     * @param {string} userId 用户ID
     * @param {string} password 密码
     */
    spnegoUserAuth(vueinstance, code) {
        // 加载开始
        vueinstance.$store.commit("loadingStart");

        // 发送请求
        return vueinstance.axios.post("/userInfo/spnegoAuth", { "userId": code })
            .then(result => {
                if (result && result.userInfo) {
                    // 用户登录信息保存
                    vueinstance.$store.commit("loginInfo", result);
                }
                // 加载完成
                vueinstance.$store.commit("loadingFinish");
                return result;
            })
            .catch(result => {
                // 加载错误
                vueinstance.$store.commit("loadingError");
            });
    },

    /**
     * 页面组信息取得
     * 
     * @param {*} vueinstance VUE实例
     * @param {string} groupId 页面组ID
     */
    findPageGroup(vueinstance, groupId) {
        // 加载开始
        vueinstance.$store.commit("loadingStart");

        // 发送请求
        return vueinstance.axios.post("/pageInfo/group", { "groupId": groupId })
            .then(result => {
                // 页面组信息保存
                if (result) {
                    vueinstance.$store.commit("pageGroupDefine", result);
                }
                // 加载完成
                vueinstance.$store.commit("loadingFinish");
                return result;
            })
            .catch(() => {
                // 加载错误
                vueinstance.$store.commit("loadingError");
            });
    },

    /**
     * 页面信息取得
     * 
     * @param {*} vueinstance VUE实例
     * @param {string} groupId 页面组ID
     * @param {string} pageId 页面ID
     */
    findPageInfo(vueinstance, groupId, pageId) {
        // 加载开始
        vueinstance.$store.commit("loadingStart");

        // 发送请求
        return vueinstance.axios.post("/pageInfo/find", { "groupId": groupId, "pageId": pageId })
            .then(result => {
                // 页面信息保存
                if (result) {
                    vueinstance.$store.commit("pageInfoDefine", result);
                    let nowLayout = result.elementSetRows[0].elementSetList[0].elementRowList[0].cellList[0].elementList[0].displayType;
                    sessionStorage.setItem('nowLayout',nowLayout)
                }
                // 加载完成
                vueinstance.$store.commit("loadingFinish");
                
                return result;
            })
            .catch(() => {
                // 加载错误
                vueinstance.$store.commit("loadingError");
            });
    },

    /**
     * 请求参数转换
     * 
     * @param {*} param 
     */
    convertProcessParam(vueinstance, param) {
        // 请求参数
        var process = new Object();

        // 补足
        if (param.a) {
            if (param.a.indexOf("p") > -1) {
                let pageInfo = vueinstance.$store.getters.curPageDefine.pageInfo;
                param.s1 = pageInfo.groupId;
                param.s2 = pageInfo.pageId;
            }
        }

        // 类型
        process.type = param.t;
        // 文字参数
        for (var i = 1; i <= 10; i++) {
            if (param['s' + i]) {
                process["stringData" + i] = param['s' + i];
            }
        }
        // 对象参数
        for (var i = 1; i <= 10; i++) {
            if (param['o' + i]) {
                process["objData" + i] = param['o' + i];
            }
        }
        // 列表参数
        for (var i = 1; i <= 10; i++) {
            if (param['l' + i]) {
                process["listData" + i] = param['l' + i];
            }
        }
        
        return process;
    },

    /**
     * 发送请求
     * 
     * @param {*} vueinstance VUE实例
     * @param {array} processList 请求一览
     * @param {string} callback 回调处理
     */
    sendProcessRequest(vueinstance, processList, callback) {
        // 加载开始
        vueinstance.$store.commit("loadingStart");

        // 发送请求
        return vueinstance.axios.post("/process/execute", processList)
            .then(result => {
                // 加载完成
                vueinstance.$store.commit("loadingFinish");
                // 实行表达式
                if (result && callback) {
                    var callBackResult = ExpressionUtil.eval(vueinstance, callback, result, processList);
                    if (callBackResult) {
                        result = callBackResult;
                    }
                }
                return result;
            })
            .catch(() => {
                // 加载错误
                vueinstance.$store.commit("loadingError");
            });
    },

    /**
     * 发送请求
     * 
     * @param {*} vueinstance VUE实例
     * @param {array} processList 请求一览
     * @param {string} callback 回调处理
     */
    sendProcessRequestWithoutLoading(vueinstance, processList, callback) {
        // 发送请求
        return vueinstance.axios.post("/process/execute", processList)
            .then(result => {
                // 实行表达式
                if (result && callback) {
                    var callBackResult = ExpressionUtil.eval(vueinstance, callback, result, processList);
                    if (callBackResult) {
                        result = callBackResult;
                    }
                }
                return result;
            });
    },

    /**
     * 读取资源数据
     * 
     * @param {*} vueinstance VUE实例
     * @param {string} resourceId 资源ID
     * @param {string} callback 回调处理
     */
    loadResource(vueinstance, resourceId, callback, responseType) {
        // 加载开始
        vueinstance.$store.commit("loadingStart");

        if (responseType == null) {
            responseType = {'responseType': 'arraybuffer'}
        } else {
            responseType = null;
        }

        // 发送请求
        return vueinstance.axios.post('/resource/download', {'resourceId': resourceId}, responseType)
            .then(result => {
                if (result) {
                    ExpressionUtil.eval(vueinstance, callback, result);
                }
                // 加载完成
                vueinstance.$store.commit("loadingFinish");
            })
            .catch(() => {
                // 加载错误
                vueinstance.$store.commit("loadingError");
            });
    },
};


// WEBPACK FOOTER //
// ./src/util/APIUtil.js